// lib/geo-distance.ts
//
// The great-circle distance, and nothing else. It lives apart from lib/geospatial.ts because that
// module imports #lib/db and axios at its top level, so a client component cannot touch it without
// dragging Prisma into the browser bundle - which is exactly why a second copy of the formula had
// been written by hand inside components/portal/BrandLocationsMap.tsx. lib/geospatial.ts re-exports
// this one, so there is still a single implementation for every server caller.

/** Earth's mean radius, in kilometres. */
export const EARTH_RADIUS_KM = 6371;

const toRad = (deg: number): number => deg * (Math.PI / 180);

/**
 * Distance between two points on Earth using the Haversine formula.
 * @returns Distance in kilometers
 */
export function haversineDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return EARTH_RADIUS_KM * c;
}
